<template>
<div class="chapter">
<div class="inner_page">
      ﻿



<title>Abbreviations</title>
<link href="template.css" rel="stylesheet" type="text/css"/>
<div id="abbreviations">
<p class="chap-ttl"><a id="pix"></a><a href="#/Table_of_contents">Abbreviations</a></p>
<p class="chap-bm-first">Only abbreviations not currently found in the <span class="epub-italic-normal-normal">SBL Handbook of Style</span> are included here.</p>
<table class="table">
<tbody>
<tr valign="top">
<td><p class="chap-bm-first">BMW</p></td>
<td><p class="chap-bm-first">Bible in the Modern World</p></td>
</tr>
<tr valign="top">
<td><p class="chap-bm-first">CTHP</p></td>
<td><p class="chap-bm-first">Cambridge Texts in the History of Philosophy</p></td>
</tr>
<tr valign="top">
<td><p class="chap-bm-first">DOML</p></td>
<td><p class="chap-bm-first">Dumbarton Oaks Medieval Library</p></td>
</tr>
<tr valign="top">
<td><p class="chap-bm-first">ER</p></td>
<td><p class="chap-bm-first">Evangelical Ressourcement</p></td>
</tr>
<tr valign="top">
<td><p class="chap-bm-first">FCBS</p></td>
<td><p class="chap-bm-first">Fortress Classics in Biblical Studies</p></td>
</tr>
<tr valign="top">
<td><p class="chap-bm-first">GSC</p></td>
<td><p class="chap-bm-first">Geneva Series Commentary</p></td>
</tr>
<tr valign="top">
<td><p class="chap-bm-first">HBISJW  </p></td>
<td><p class="chap-bm-first">HBI Series on Jewish Women</p></td>
</tr>
<tr valign="top">
<td><p class="chap-bm-first">HBM</p></td>
<td><p class="chap-bm-first">Hebrew Bible Monographs</p></td>
</tr>
<tr valign="top">
<td><p class="chap-bm-first">JSRC</p></td>
<td><p class="chap-bm-first">Jerusalem Studies in Religion and Culture</p></td>
</tr>
<tr valign="top">
<td><p class="chap-bm-first">LOLA</p></td>
<td><p class="chap-bm-first">Library of Liberal Arts</p></td>
</tr>
<tr valign="top">
<td><p class="chap-bm-first">NCE</p></td>
<td><p class="chap-bm-first">Norton Critical Editions</p></td>
</tr>
<tr valign="top">
<td><p class="chap-bm-first">OECS</p></td>
<td><p class="chap-bm-first">Oxford Early Christian Studies</p></td>
</tr>
<tr valign="top">
<td><p class="chap-bm-first">OTT</p></td>
<td><p class="chap-bm-first">Old Testament Theology</p></td>
</tr>
<tr valign="top">
<td><p class="chap-bm-first"><span class="epub-italic-normal-normal">PMLA</span></p></td>
<td><p class="chap-bm-first"><span class="epub-italic-normal-normal">Publications of the Modern Language Association of America</span></p></td>
</tr>
<tr valign="top">
<td><p class="chap-bm-first">RSMRC</p></td>
<td><p class="chap-bm-first">Routledge Studies in Medieval Religion and Culture</p></td>
</tr>
<tr valign="top">
<td><p class="chap-bm-first">STI</p></td>
<td><p class="chap-bm-first">Studies in Theological Interpretation</p></td>
</tr>
<tr valign="top">
<td><p class="chap-bm-first">TatC</p></td>
<td><p class="chap-bm-first">Texts @ Contexts</p></td>
</tr>
<tr valign="top">
<td><p class="chap-bm-first">TSC</p></td>
<td><p class="chap-bm-first">Theology and the Sciences</p></td>
</tr>
<tr valign="top">
<td><p class="chap-bm-first">WPL</p></td>
<td><p class="chap-bm-first">Wordsworth Poetry Library</p></td>
</tr>
</tbody>
</table>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Abbreviations.vue?8651c040